<template>
  <span v-if="darkMode">
    <img
      v-if="cardType.toUpperCase() == 'VISA'"
      class="cardType"
      src="@/assets/img/visa_white.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'AMERICAN_EXPRESS'"
      src="@/assets/img/amex_white.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'DINERS_CLUB'"
      src="@/assets/img/diners_white.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'JCB'"
      src="@/assets/img/jcb_white.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'MASTERCARD'"
      src="@/assets/img/mastercard_white.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'DISCOVER'"
      src="@/assets/img/discover_white.svg"
    />
  </span>
  <span v-else>
    <img
      v-if="cardType.toUpperCase() == 'VISA'"
      class="cardType"
      src="@/assets/img/visa.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'AMERICAN_EXPRESS'"
      src="@/assets/img/amex.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'DINERS_CLUB'"
      src="@/assets/img/diners.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'JCB'"
      src="@/assets/img/jcb.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'MASTERCARD'"
      src="@/assets/img/mastercard.svg"
    />
    <img
      class="cardType"
      v-if="cardType.toUpperCase() == 'DISCOVER'"
      src="@/assets/img/discover.svg"
    />
  </span>
</template>

<script>
export default {
  name: "card-svg",
  props: {
    cardType: null,
  },
  data() {
    return {
      darkMode: false,
    };
  },
  created() {
    var current = this.$localStorageService.getItem("data-theme");
    if (current && current == "dark") {
      this.darkMode = true;
    } else {
      this.darkMode = false;
    }
  },
};
</script>

<style>
.cardType {
  height: 20px;
}
</style>
